const fromMillisecondsToSeconds = (value) => parseInt(value / 1000, 10);
const toMillisecondsFromSeconds = (value) => parseInt(value, 10) * 1000;
const toUnixTimestamp = (value) => fromMillisecondsToSeconds(value);
const fromUnixTimestamp = (value) => toMillisecondsFromSeconds(value);
const now = () => toUnixTimestamp((new Date()).getTime());

export {
    fromUnixTimestamp,
    toUnixTimestamp,
    now,
};
